import { Input } from '@iwoca/orion';
import { UseFormRegister } from 'react-hook-form';
import { FormattedMessage } from 'react-intl';

import { DebitCardFieldWrapper } from '../../DebitCardFieldWrapper';
import { TFormValues } from '../StripeLinkDebitCardForm';

export function BillingPostcodeField({
    formRegister,
    error,
    className,
    placeholder = 'e.g. N6 6NG'
}: {
    formRegister: UseFormRegister<TFormValues>;
    error?: string;
    className?: string;
    placeholder?: string;
}) {
    return (
        <DebitCardFieldWrapper
            label={
                <FormattedMessage
                    id="_.link_debit_card.billing_postcode"
                    defaultMessage="Billing postcode"
                />
            }
            htmlFor="billingPostcode"
            error={error ?? null}
            className={className}
        >
            <Input
                type="text"
                id="billingPostcode"
                placeholder={placeholder}
                className="fs-exclude"
                {...formRegister('billingPostcode')}
            />
        </DebitCardFieldWrapper>
    );
}
